/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Webauthn_Invalid_HandleInputs */



/**
* | output |
* | --- |
* | "Passkey not found. Please check your device or try a different one." |
*
* @param {Auth_Webauthn_Invalid_HandleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_webauthn_invalid_handle = /** @type {((inputs?: Auth_Webauthn_Invalid_HandleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Webauthn_Invalid_HandleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Passkey nicht gefunden. Bitte überprüfe dein Gerät oder versuche ein anderes.")
	return /** @type {LocalizedString} */ ("Passkey not found. Please check your device or try a different one.")
});